const widgetTokenStores = new Map<string | symbol, WidgetTokenStore>();

export interface WidgetTokenStore {
  set(token: string): void;
  get(throwIfNotFound?: boolean): string | undefined;
}

export function createWidgetTokenStore(): WidgetTokenStore {
  let token: string | undefined = undefined;

  return {
    set(newToken: string) {
      token = newToken;
    },
    get(throwIfNotFound = true) {
      if (!token && throwIfNotFound) {
        throw new Error('Widget token is not stored');
      }

      return token;
    }
  };
}

export function getWidgetTokenStore(
  widgetId: string | symbol
): WidgetTokenStore {
  if (!widgetTokenStores.has(widgetId)) {
    widgetTokenStores.set(widgetId, createWidgetTokenStore());
  }
  return widgetTokenStores.get(widgetId)!;
}
